<template>
  <header class="app-header" v-if="fs.show('Header')">
    <v-img v-if="fs.show('Logo')" :src="logoSrc" max-width="110" max-height="37" style="cursor: pointer;margin-top: 15px;" v-on:click="showInfo"></v-img>
    <div class="inner-rounded-container">
      <div class="inner2-rounded-container">
          <ToolButton 
            v-if="fs.show('Account')" 
            :disabled="fs.disabled('Account')"
            icon="person" 
            :title="$vuetify.breakpoint.mdAndUp?userTitle:undefined" 
            v-on:click="openUserInfo" 
            :tool-tip="$t('message.user_info_btn')" 
            no-tr
          />
          <div v-show="!type" style="display: flex; align-items: center;" v-if="fs.show('Messages.View') || (fs.show('Messages.Send') && globalState.curFolderName && globalState.userMsgReady)">
            <ToolButton 
              :danger="newNoti>0"
              v-if="fs.show('Messages.View')" 
              :disabled="fs.disabled('Messages.View')"
              :icon="$vuetify.breakpoint.mdAndUp?undefined:'mail'" 
              :title="$vuetify.breakpoint.mdAndUp?(newNoti + ' ' + $t('message.messages')):undefined" 
              :tool-tip="$t('message.notify_list_btn')" 
              v-on:click="openNotify" 
              :groupStart="fs.show('Messages.Send') && globalState.curFolderName && globalState.userMsgReady" 
              no-tr/>
            <ToolButton 
              v-if="fs.show('Messages.Send') && globalState.curFolderName && globalState.userMsgReady" 
              :disabled="fs.disabled('Messages.Send')"
              icon="send" 
              v-on:click="()=>newMsg()" 
              tool-tip="message.send_user_msg" 
              groupEnd/>
          </div>
          <ToolButton
            v-if="fs.show('Logout')" 
            :disabled="fs.disabled('Logout')"
            icon="logout" 
            :title="$vuetify.breakpoint.mdAndUp?'message.logout_ttl':undefined" 
            v-on:click="logOut"
          />

          <div style="flex:1 1; display: flex; align-items: center;justify-content: center;" v-if="fs.show('DownloadByHASH')">
            <div style="min-width: 20px;"></div>
            <ToolButton 
              :disabled="fs.disabled('DownloadByHASH')"
              icon="file_download" 
              :title="$vuetify.breakpoint.mdAndUp?'message.down_ttl':undefined" 
              v-on:click="downloadFile"/>
            <div style="min-width: 20px;"></div>
          </div>

          <v-menu offset-y v-if="fs.show('LanguageSwitch')">
            <template v-slot:activator="{ on }">
              <v-btn small fab text v-on="on" id="toolbarLang"  :disabled="fs.disabled('LanguageSwitch')">{{langInfo.locale}}</v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="l in langs" :key="l" @click="setLang( l )">
                <v-list-item-title>{{ l }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <ToolButton 
            v-if="fs.show('Help')" 
            :disabled="fs.disabled('Help')" 
            icon="help" 
            v-on:click="openHelp" 
            tool-tip="message.help_btn"/>
      </div>
      <div v-on:click="showInfo" v-if="fs.show('AppName') && $vuetify.breakpoint.mdAndUp" id="appname">
        <svg height="62" viewBox="0 0 105.892 34.055"><path d="M18.74 3.578v8.271a6.97 6.97 0 0 1 .795-.057 6.97 6.97 0 0 1 6.043 3.502h5.698C30.201 8.635 25.517 4.091 18.74 3.578z" fill="#969797"/><path d="M17.482 8.177c-8.146.871-12.612 6.67-12.785 13.086h8.352a6.97 6.97 0 0 1-.483-2.502 6.97 6.97 0 0 1 4.908-6.651l.008-3.933z" fill="#05868c"/><path d="M26.134 16.525a6.97 6.97 0 0 1 .371 2.236 6.97 6.97 0 0 1-3.805 6.192v2.37c4.041-1.783 6.457-5.007 7.196-10.798h-3.762z" fill="#fc0938"/><path d="M10.269 22.446c1.686 4.99 5.997 7.684 11.088 8.209l.071-5.192a6.97 6.97 0 0 1-1.892.267 6.97 6.97 0 0 1-5.902-3.274l-3.364-.01z" fill="#fadc0b"/><path d="M37.221 15.267h2.853v-.559h-2.21V12.49h1.609v-.559h-1.609V9.899h2.21V9.34h-2.853zm3.006 0h.677l1.177-2.455 1.177 2.455h.711l-1.507-3.056 1.422-2.87h-.677l-1.101 2.294-1.092-2.294h-.711l1.422 2.879zm3.903 0h.643v-2.515h.872c1.05 0 1.693-.61 1.693-1.702 0-1.118-.652-1.71-1.71-1.71H44.13zm1.473-5.368c.686 0 1.101.356 1.101 1.151s-.415 1.151-1.101 1.151h-.83V9.899zm2.083 5.368h.643V12.6h.982c.5 0 .779.237.779.838 0 .991.025 1.473.169 1.829h.66c-.169-.466-.195-1.024-.195-1.778 0-.61-.169-1.008-.652-1.168.516-.229.813-.728.813-1.414 0-.991-.643-1.566-1.6-1.566h-1.6zm1.558-5.368c.593 0 1.008.356 1.008 1.075 0 .711-.406 1.084-1.008 1.084h-.914V9.899zm2.024 5.368h2.853v-.559h-2.21V12.49h1.609v-.559h-1.609V9.899h2.21V9.34h-2.853zm4.699.076c.914 0 1.499-.601 1.499-1.516 0-.974-.703-1.431-1.363-1.846-.593-.373-1.16-.703-1.16-1.346 0-.474.313-.821.821-.821.635 0 .999.474 1.075 1.448h.593c-.076-1.312-.677-1.998-1.676-1.998-.872 0-1.439.567-1.439 1.414 0 .948.72 1.389 1.389 1.803.584.373 1.143.728 1.143 1.405a.85.85 0 0 1-.906.906c-.669 0-1.016-.483-1.084-1.516h-.61c.068 1.355.66 2.066 1.719 2.066zm3.463 0c.914 0 1.499-.601 1.499-1.516 0-.974-.703-1.431-1.363-1.846-.593-.373-1.16-.703-1.16-1.346 0-.474.313-.821.821-.821.635 0 .999.474 1.075 1.448h.593c-.076-1.312-.677-1.998-1.676-1.998-.872 0-1.439.567-1.439 1.414 0 .948.72 1.389 1.389 1.803.584.373 1.143.728 1.143 1.405a.85.85 0 0 1-.906.906c-.669 0-1.016-.483-1.084-1.516h-.61c.068 1.355.66 2.066 1.719 2.066zm3.697-.076h1.126c1.372 0 2.278-.991 2.278-2.955 0-1.981-.889-2.972-2.252-2.972h-1.151zm1.126-5.359c1.008 0 1.634.737 1.634 2.405 0 1.651-.627 2.396-1.634 2.396h-.483V9.908zm3.59 5.419c.415 0 .77-.203.999-.516v.457h.601v-3.336c0-.779-.491-1.219-1.236-1.219-.787 0-1.321.576-1.38 1.507h.576c.051-.66.339-1.016.787-1.016.389 0 .652.246.652.618 0 .356-.305.627-.847.94-.66.381-1.236.754-1.236 1.482 0 .652.432 1.084 1.084 1.084zm-.483-1.118c0-.516.406-.787.897-1.092.246-.152.457-.305.593-.483l-.008.491v1.253a.99.99 0 0 1-.838.466c-.356 0-.643-.229-.643-.635zm3.785 1.058h.762v-.5h-.5c-.271 0-.389-.11-.389-.364v-3.107h.889v-.508h-.889v-.847H70.4v.847h-.728v.508h.728v3.234c0 .466.246.737.745.737zm2.024.059c.415 0 .77-.203.999-.516v.457h.601v-3.336c0-.779-.491-1.219-1.236-1.219-.787 0-1.321.576-1.38 1.507h.576c.051-.66.339-1.016.787-1.016.389 0 .652.246.652.618 0 .356-.305.627-.847.94-.66.381-1.236.754-1.236 1.482 0 .652.432 1.084 1.084 1.084zm-.483-1.118c0-.516.406-.787.897-1.092.246-.152.457-.305.593-.483l-.008.491v1.253a.99.99 0 0 1-.838.466c-.356 0-.643-.229-.643-.635zm4.366 1.058h.576l-.034-5.41.5 2.447.627 2.963h.635l.627-2.963.483-2.43-.017 2.43-.017 2.963h.593V9.34h-.982l-.5 2.421-.5 2.506-.5-2.506-.5-2.421h-.991zm5.427.059c.415 0 .77-.203.999-.516v.457h.601V11.93c0-.779-.491-1.219-1.236-1.219-.787 0-1.321.576-1.38 1.507h.576c.051-.66.339-1.016.787-1.016.389 0 .652.246.652.618 0 .356-.305.627-.847.94-.66.381-1.236.754-1.236 1.482 0 .652.432 1.084 1.084 1.084zm-.483-1.118c0-.516.406-.787.897-1.092.246-.152.457-.305.593-.483l-.008.491v1.253a.99.99 0 0 1-.838.466c-.356 0-.643-.229-.643-.635zm2.532 1.058h.618v-3.598a.92.92 0 0 1 .796-.457c.44 0 .711.288.711.77v3.285h.618V11.88c0-.703-.457-1.151-1.143-1.151-.415 0-.762.203-.982.508v-.449h-.618zm4.174.059c.415 0 .77-.203.999-.516v.457h.601v-3.336c0-.779-.491-1.219-1.236-1.219-.787 0-1.321.576-1.38 1.507h.576c.051-.66.339-1.016.787-1.016.389 0 .652.246.652.618 0 .356-.305.627-.847.94-.66.381-1.236.754-1.236 1.482 0 .652.432 1.084 1.084 1.084zm-.483-1.118c0-.516.406-.787.897-1.092.246-.152.457-.305.593-.483l-.008.491v1.253a.99.99 0 0 1-.838.466c-.356 0-.643-.229-.643-.635zm3.818 1.109c.457 0 .821-.262 1.041-.77v.881c-.008.677-.33 1.016-.847 1.016-.474 0-.779-.254-.872-.796h-.593c.11.83.669 1.253 1.465 1.253.889 0 1.465-.525 1.465-1.583v-4.53h-.61v.728c-.22-.525-.584-.787-1.05-.787-.813 0-1.372.787-1.372 2.286 0 1.516.55 2.303 1.372 2.303zm.144-.5c-.542 0-.897-.567-.897-1.803 0-1.219.356-1.803.897-1.803.55 0 .897.593.897 1.803 0 1.219-.347 1.803-.897 1.803zm3.37.533c.796 0 1.304-.61 1.422-1.753h-.567c-.102.838-.398 1.253-.855 1.253-.542 0-.872-.601-.872-1.82v-.008h2.328v-.085c0-1.465-.593-2.235-1.448-2.235-.923 0-1.49.847-1.49 2.328 0 1.516.576 2.32 1.482 2.32zm.008-4.149c.449 0 .762.457.847 1.38h-1.71c.076-.914.389-1.38.864-1.38zm1.812 4.064h.618v-3.421a.95.95 0 0 1 .855-.508.83.83 0 0 1 .203.025v-.618c-.034 0-.068-.008-.102-.008-.398 0-.754.229-.957.627v-.576h-.618zM72.2 18.748h.241v-2.013h.527v-.21h-1.292v.21h.524zm1.005 0h.216l-.013-2.029.187.918.235 1.111h.238l.235-1.111.181-.911-.006.911-.006 1.111h.222v-2.222h-.368l-.187.908-.187.94-.187-.94-.187-.908h-.371zm-33.928 3.704h1.126v-5.029h2.032v-.897h-5.182v.897h2.024zm3.234 0h1.084v-3.141c.229-.373.677-.567 1.16-.567.11 0 .22.008.33.025v-.991h-.11a1.52 1.52 0 0 0-1.38.804v-.728h-1.084zm4.555.093c.567 0 1.05-.246 1.372-.635v.542h1.084v-4.597h-1.084v3.395a1.22 1.22 0 0 1-.991.5c-.559 0-.931-.33-.931-.931v-2.963h-1.084v3.133c0 .94.643 1.558 1.634 1.558zm5.055.017c1.151 0 1.93-.677 2.134-1.829H53.23c-.152.694-.542 1.05-1.101 1.05-.686 0-1.126-.533-1.16-1.524h3.336v-.085c0-1.558-.931-2.438-2.176-2.438-1.312 0-2.227.931-2.227 2.421 0 1.499.897 2.405 2.218 2.405zm0-4.047c.559 0 .957.381 1.101 1.101h-2.21c.135-.711.542-1.101 1.109-1.101zm2.591 3.937h1.126V20.14h1.668c1.262 0 2.032-.694 2.032-1.803 0-1.126-.779-1.812-2.049-1.812h-2.777zm2.701-5.038c.635 0 1.008.322 1.008.931s-.373.923-1.008.923h-1.575v-1.854zm2.506 5.038h4.284v-.889h-3.158v-5.038h-1.126zm4.674 0h1.016l-.008-2.921-.025-1.913.559 1.913.864 2.921h1.058l.864-2.921.559-1.913-.025 1.913-.008 2.921h1.05v-5.927h-1.634l-.66 2.218-.652 2.21-.652-2.21-.669-2.218h-1.634z"/></svg>
      </div>

    </div>
  </header> 
</template>

<script>
/*
<v-list-item @click.stop="showInfo">
  <v-list-item-action>
    <v-icon>question_answer</v-icon>
  </v-list-item-action>
    <v-list-item-title class="big">{{ $t( 'message.info_ttl' ) }}</v-list-item-title>
    <v-tooltip bottom>
          <template v-slot:activator="{ on }">
              <v-icon slot="activator" @click.stop="openHelp( 'About-(for-a-project-user)' )" class='questionIcon'>help_outline</v-icon>
          </template>
          <span>
               {{$t( 'message.open_help' )}}
          </span>
    </v-tooltip>
</v-list-item>
 */

import{ conf } from '@/utils/confTruePLM';  
import ToolButton from "./ToolButton.vue";
import FeaturesSet from "@/utils/features"
export default {
  name: 'tool-bar',
  props: {
      type: null
  },
  data () 
  {
      return {
        fs: FeaturesSet,
        proj: null,
        langInfo: this.$i18n,
        globalState: this.$globalStore.state
      };
  },
  computed: {
    userTitle(){
      let user = this.$globalStore.state.curUser;
      if (!user) return this.$t("message.nouser_account_btn");
      let role;
      if( this.proj ) role = this.$utils.clearType( this.proj.userType );
      return user + (role? ('('+role+')'): '');
    },
    langs() 
    {
          return Object.keys( this.$i18n.messages );
    },
    logoSrc: function()
    { 
          return require( '../assets/logo_EPM.svg' );  
    },
    newNoti()
    {
        let cnt = 0;
        this.$globalStore.state.notifications.forEach( n =>
        {
            if( n.noti.open && !n.noti.viewed )
                cnt++;
        } );
        return cnt;
    }
  },
  methods: {
      logOut(){
          this.$modalDlg.sysDlgs.logoutDlg.open( null, null, false, true );  
      },
      downloadFile()
      {
          let self = this;
          this.$modalDlg.sysDlgs.confirmOneValDlg.open( 'down_file_hash_title', 'down_file_hash_msg' )
                  .then( ( hash ) =>
          {
              self.$modalDlg.sysDlgs.progressDlg.open();
              return conf.getDocByHash( hash );
          }, () => {} )
                  .then( ( flInfo ) =>
          {
              self.$modalDlg.sysDlgs.progressDlg.close();
              if( flInfo )
              {
                  let url = conf.getFileLink( flInfo.title, flInfo.source );
                  window.location.href = encodeURI( url );  
              }
          })
                  .catch( ( err ) =>
          {
              self.$modalDlg.sysDlgs.progressDlg.close();
              self.$eventBus.$emit( 'queryError', err );
          });
      },
      showInfo()
      {
          this.$modalDlg.sysDlgs.infoDlg.open();  
      },
      newMsg( info )
      {
          let self = this;
          if( !info )
              info = {}; 
 //console.log( info );         
          self.$modalDlg.sysDlgs.addP2PMsgDlg.open( info.node, info.file, info.subj, info.users, info.type,
                                                    info.status, info.end_date, info.proj )
                .then( data =>
          {
            //  console.log( data );
              return conf.addP2PMsg( data.subj, data.text, data.users, data.node, data.doc, info.id,
                                        data.type, data.status, data.end_date, info.proj );
          }, () => {} )
                .then( rez => 
          {
             // console.log( rez );
              if( rez )
              {
                   self.$modalDlg.sysDlgs.confirmDlg.openOkOnly( 'send_msg_title', 'send_msg_msg' );
                   return conf.listUserNTasks( info.proj );
              }
              else if( rez !== undefined )
                  self.$modalDlg.sysDlgs.confirmDlg.openWarning( 'send_msg_title', 'not_send_msg_msg', true );
          })
                  .then( data => 
          {
              if( data )
                  self.$globalStore.procProjNotifications( ( info.proj || conf.getProj() ).in_project, data );
          })
                  .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          });
      },
      openNotify()
      {
          let self = this;
          self.$modalDlg.sysDlgs.userNotiDlg.open();
      },
      openHelp()
      {
          let link = '';
          if( this.type === 'props' )
              link = 'Reference-data-definitions';
          else if( this.type === 'ntasks' )
              link = 'Notification';
          else if( this.type === 'orgs' )
              link = 'Organisation';
          else if( this.type === 'prods' )
              link = 'Product';
          else if( this.type === 'actions' )
              link = 'System-notifications-of-changes-in-the-Breakdown';
          else if( this.type === 'triggers' )
              link = 'System-notifications-of-changes-in-the-Breakdown';
            
          this.$utils.openHelp( link );
      },
      openUserInfo()
      {
           this.$modalDlg.sysDlgs.userInfoDlg.open();  
      },
      setLang( l )
      {
          this.$i18n.locale = l;
      },
    },
  components: {
    ToolButton: ToolButton 
  },
  mounted: function()
  {
      let self = this;
      self.$eventBus.$on( 'sendNewMsg', function( info )
      {
          self.newMsg( info );
      });
      self.$eventBus.$on( 'selectedModel', function()
      {
        self.proj = conf.getProj();
      });
  },
  beforeDestroy: function()
  {
      this.$eventBus.$off( 'sendNewMsg' );
      this.$eventBus.$off( 'selectedModel' );
  }
}
</script>

<style scoped>
  header.app-header{
    display: flex;
    padding-left: 10px;
    padding-bottom: 8px;
  }
  .inner-rounded-container{
    position: relative;
    display:flex;
    flex: 1 1;
    gap: 30px;
    align-items: center;
    justify-content: flex-end;
    padding-left: 30px;
    padding-right: 10px;
/*
    border-bottom-left-radius: 20px;
    background-color: var(--brand-light-color);
    border-bottom: 1px solid rgba(100, 127, 129, 0.2);
    border-left: 1px solid rgba(100, 127, 129, 0.2);
    -webkit-box-shadow: 0px 0px 3px 2px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 0px 3px 2px rgba(0,0,0,0.15);
    box-shadow: 0px 0px 3px 2px rgba(0,0,0,0.15);*/
  }

  .inner2-rounded-container{
    display: flex;
    gap: 8px;
    height: 50px;
    align-items: center;
    padding: 0 16px;
    margin-bottom: 10px;
    background-color: #5cb4b8;
    border-bottom: 1px solid rgba(3, 75, 79, 0.1);
    border-left: 1px solid rgba(3, 75, 79, 0.1);
    border-right: 1px solid rgba(3, 75, 79, 0.1);
    -webkit-box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.15);
    box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.15);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    z-index: 2;
  }

  #appname{
    position: absolute;
    left: 0px;
    top: 0px;
    cursor: pointer;
    font-size: 29px;
    font-weight:bold;
    fill:#777;
    z-index: 1;
  }

  #toolbarLang{
    color: white;
    font-weight: bold;
  }

</style>




